import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/tou_xiang.png'
import _imports_1 from '../../assets/icon/tou_xiang.png'


const _withScopeId = n => (_pushScopeId("data-v-144b0f9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project_detail" }
const _hoisted_2 = { class: "top_img" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  fit: "cover",
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "custom-indicator" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "div_line" }
const _hoisted_11 = { class: "topic" }
const _hoisted_12 = { class: "detail" }
const _hoisted_13 = { class: "div_line" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title_line" }, "联系方式", -1))
const _hoisted_15 = { class: "label_name" }
const _hoisted_16 = { class: "div_line" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title_line" }, "所在城市", -1))
const _hoisted_18 = { class: "label_name" }
const _hoisted_19 = { class: "div_line" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title_line" }, "资源类型", -1))
const _hoisted_21 = { class: "label_name" }
const _hoisted_22 = {
  key: 0,
  class: "div_line"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title_line" }, "附件", -1))
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  class: "div_line",
  style: {"border":"none"}
}
const _hoisted_26 = { class: "title_line" }
const _hoisted_27 = { class: "comment" }
const _hoisted_28 = ["id"]
const _hoisted_29 = { class: "name" }
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  fit: "cover",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_32 = { class: "time" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "dialog_content" }
const _hoisted_35 = { class: "button_two" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("发送")
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "children"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  key: 0,
  class: "name"
}
const _hoisted_41 = ["src"]
const _hoisted_42 = {
  key: 1,
  class: "name"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  fit: "cover",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_44 = { class: "time" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 1,
  class: "footer_pl_button"
}
const _hoisted_49 = /*#__PURE__*/_createTextVNode("发送")
const _hoisted_50 = {
  key: 2,
  class: "num_tatal"
}
const _hoisted_51 = { class: "p_l" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

import { ref, onMounted, nextTick } from "vue"
import { showImagePreview } from "vant"
import router from "@/router"
import { useRoute } from "vue-router"
import {
  getDetailApi,
  getCommentApi,
  commentApi,
  removeCommentApi,
  upvoteApi,
  removeUpvoteApi,
  collectApi,
  getOffDetailApi,
  removeCollectApi
} from "@/api/projectDemand"
import { showNotify, showLoadingToast, closeToast, showConfirmDialog } from "vant"
import ListWithRefreshAndLazyLoad from "@/components/ListWithRefreshAndLazyLoad.vue"
import { areaList } from "@vant/area-data"
import DataList from "@/api/common"
import commons from "@/utils/commons"
import { getTokenIn } from "@/utils/cookies"
import { authoritiesApi } from "@/api/user" // 获取用户权限

export default /*#__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props) {

const route = useRoute()
const getDataAPI = getCommentApi
const listRef = ref()
const list: any = ref([])
const total = ref(0)
const showFlag = ref(false)
const inputValue = ref("")
const hfValue = ref()
const showDialog = ref(false)
const inputRef = ref()
const bottomInputRef = ref()
const aa = ref("")
const commentContent = ref() //底部输入框评论
const dzShow = ref(true) //点赞按钮权限控制
const plShow = ref(true) //评论按钮权限控制
const scShow = ref(true) //收藏按钮权限控制
const inputDisabled = ref(false)
const inputDisabled2 = ref(false)
const params: any = ref({
  projectRequireSfid: route.query.id
})
const ADDNUM = ref(0)
const datas: any = ref({
  isDelete: "",
  zt: "",
  img: [
    { url: "http://localhost:8848/src/assets/login/c2.png" },
    { url: "http://localhost:8848/src/assets/login/c2.png" }
  ],
  file: [
    { name: "《基础设施和公用事业特许经营管理办法》.pdf" },
    { name: "《基础设施和公用事业特许经营管理办法》.pdf" }
  ],
  comment: [
    {
      url: "https://console.xmdifon.com/minio/page/company_login.png",
      name: "张小飞",
      content:
        "城市更新千万不能随意跟风包装、创设各类特许经营项目，因为只有真正合法合规的特许经营项目才能获得金融机构的融资，才能提高公共产品和服务的质量与效率，惠及百姓，真正实现政府特许经营的目的。",
      time: "2024-03-25  12:12:13",
      children: [
        {
          url: "https://console.xmdifon.com/minio/page/company_login.png",
          name: "张小飞1-1",
          content:
            "城市更新千万不能随意跟风包装、创设各类特许经营项目，因为只有真正合法合规的特许经营项目才能获得金融机构的融资，才能提高公共产品和服务的质量与效率，惠及百姓，真正实现政府特许经营的目的。",
          time: "2024-05-25  12:12:13"
        },
        {
          url: "https://console.xmdifon.com/minio/page/company_login.png",
          name: "张小飞1-2",
          content:
            "城市更新千万不能随意跟风包装、创设各类特许经营项目，因为只有真正合法合规的特许经营项目才能获得金融机构的融资，才能提高公共产品和服务的质量与效率，惠及百姓，真正实现政府特许经营的目的。",
          time: "2024-05-25  12:12:13"
        }
      ]
    },
    {
      url: "https://console.xmdifon.com/minio/page/company_login.png",
      name: "张小飞2",
      content:
        "城市更新千万不能随意跟风包装、创设各类特许经营项目，因为只有真正合法合规的特许经营项目才能获得金融机构的融资，才能提高公共产品和服务的质量与效率，惠及百姓，真正实现政府特许经营的目的。",
      time: "2024-03-25  12:12:13",
      children: [
        {
          url: "https://console.xmdifon.com/minio/page/company_login.png",
          name: "张小飞2-1",
          content:
            "城市更新千万不能随意跟风包装、创设各类特许经营项目，因为只有真正合法合规的特许经营项目才能获得金融机构的融资，才能提高公共产品和服务的质量与效率，惠及百姓，真正实现政府特许经营的目的。",
          time: "2024-05-25  12:12:13"
        },
        {
          url: "https://console.xmdifon.com/minio/page/company_login.png",
          name: "张小飞2-2",
          content:
            "城市更新千万不能随意跟风包装、创设各类特许经营项目，因为只有真正合法合规的特许经营项目才能获得金融机构的融资，才能提高公共产品和服务的质量与效率，惠及百姓，真正实现政府特许经营的目的。",
          time: "2024-05-25  12:12:13"
        }
      ]
    }
  ]
})
const current = ref(0)
const onChange = (index: number) => {
  current.value = index
}
onMounted(() => {
  // getAuthorities() //获取用户权限
  if (route.query.id) {
    getDtail(route.query.id)
  }
})
// 获取用户所有权限
const getAuthorities = () => {
  authoritiesApi().then((res: any) => {
    if (res.code == 200) {
      res.data.map((item: any) => {
        if (item.perms == "pdz" || item.name == "项目需求-点赞") {
          dzShow.value = true
        } else if (item.perms == "ppl" || item.name == "项目需求-评论") {
          plShow.value = true
        } else if (item.perms == "psc" || item.name == "项目需求-收藏") {
          scShow.value = true
        }
      })
    } else {
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 获取详情
const getDtail = async (id: any) => {
  showLoadingToast({
    message: "加载中",
    duration: 0
  })
  const newUrl = route.query.status === "off-shelf" ? getOffDetailApi : getDetailApi
  console.log(route.query.status === "off-shelf")
  newUrl(id).then((res: any) => {
    closeToast()
    if (res.code == 200) {
      datas.value = res.data
      closeToast()
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 获取头像
const getImg = (sfid: string) => {
  var url = DataList.UpdtImagePrefix() + sfid
  return url
}
// 获取行政区名称
const getAreaName = (item: string) => {
  var string = item + ""
  const name = string.split(",")
  let areaName = ""
  name.map((i) => {
    areaName += areaList.province_list[i] || areaList.city_list[i] || areaList.county_list[i] || "未知区域"
  })
  return areaName
}
const getData = (val: any) => {
  total.value = val
}
// 点击回复
const focusInput = (val: any, name: any, index: number) => {
  hfValue.value = val
  inputValue.value = ""
  showDialog.value = true
  const names = `回复@${name}：`
  aa.value = names
  setTimeout(() => {
    // console.log(inputRef)
    // console.log(index)
    inputRef.value[index].focus()
  }, 200)
}
// 回复确认按钮
const onClickConfirm = async () => {
  if (!inputValue.value) {
    showNotify({ type: "warning", message: "请输入回复内容" })
  } else if (datas.value.zt == "off-shelf" || datas.value.isDelete == "1") {
    showNotify({ type: "warning", duration: 600, message: "需求被下架或删除" })
    router.push({ path: "/projectDemand" })
  } else {
    // 安全检测
    inputDisabled2.value = true
    const secdatas = await commons.secureCheck({
      content: inputValue.value,
      openId: localStorage.getItem("openId"),
      scene: 2
    })
    if (secdatas.code == 200) {
      inputDisabled2.value = false
      if (secdatas.data?.suggest == "pass") {
        var datas2 = {
          commentContent: inputValue.value,
          projectRequireSfid: route.query.id,
          sfid: hfValue.value.sfid
        }
        showLoadingToast({
          message: "保存中"
        })
        commentApi(datas2).then((res: any) => {
          closeToast()
          inputDisabled2.value = false
          if (res.code == 200) {
            showDialog.value = false
            closeToast()
            if (res.data == "201" || res.data == "202") {
              showNotify({ type: "warning", duration: 600, message: res.message })
              router.push({ path: "/projectDemand" })
            } else {
              showNotify({ type: "success", message: "回复成功" })
              // 刷新数据
              getDtail(route.query.id)
              // 刷新数据
              list.value = []
              listRef.value?.onRefresh()
            }
          } else {
            inputDisabled2.value = false
            closeToast()
            showNotify({ type: "danger", message: res.message })
          }
        })
      } else {
        inputDisabled2.value = false
      }
    } else {
      inputDisabled2.value = false
    }
  }
}
// 评论展开收起
const zk = (item: any, index: any) => {
  console.log("点击展开操作")
  item.showFlag = !item.showFlag
  console.log(!list.value[index].ADDNUM)
  if (!list.value[index].ADDNUM) {
    list.value[index].ADDNUM = 0
    console.log(list.value[index].ADDNUM)
  }
  list.value[index].ADDNUM += 1
  console.log(list.value[index].ADDNUM)
  console.log("结束展开操作")
}
// 评论删除
const onClickDelete = (item: any) => {
  showConfirmDialog({
    // title: "标题",
    message: "确认删除该评论吗？"
  })
    .then(() => {
      showLoadingToast({
        message: "删除中"
      })
      removeCommentApi({ sfid: item.sfid }).then((res: any) => {
        closeToast()
        if (res.code == 200) {
          closeToast()
          showNotify({ type: "success", message: "删除成功" })
          // 刷新数据
          getDtail(route.query.id)
          // 刷新数据
          list.value = []
          listRef.value?.onRefresh()
        } else {
          closeToast()
          showNotify({ type: "danger", message: res.message })
        }
      })
    })
    .catch(() => {
      // 取消
    })
}
const isShowOperate = ref(true)
const onFocus = () => {
  isShowOperate.value = false //聚焦的时候隐藏点赞评论按钮
}
// 底部评论
const onSearch = async () => {
  if (!commentContent.value) {
    // bottomInputRef
    isShowOperate.value = true //放开点赞评论按钮
    showNotify({ type: "warning", message: "请输入评论" })
  } else if (!getTokenIn()) {
    isShowOperate.value = true //放开点赞评论按钮
    showNotify({ type: "warning", duration: 500, message: "请登录" })
  } else if (datas.value.zt == "off-shelf" || datas.value.isDelete == "1") {
    isShowOperate.value = true //放开点赞评论按钮
    showNotify({ type: "warning", duration: 900, message: "需求被下架或删除" })
    router.push({ path: "/projectDemand" })
  } else {
    // 安全检测
    inputDisabled.value = true
    const secdatas = await commons.secureCheck({
      content: commentContent.value,
      openId: localStorage.getItem("openId"),
      scene: 2
    })
    if (secdatas.code == 200) {
      inputDisabled.value = false
      if (secdatas.data?.suggest == "pass") {
        showLoadingToast({
          message: "保存中"
        })
        isShowOperate.value = true //放开点赞评论按钮
        var datas2 = {
          commentContent: commentContent.value,
          projectRequireSfid: route.query.id
          // sfid: hfValue.value.sfid
        }
        commentApi(datas2).then((res: any) => {
          inputDisabled.value = false
          closeToast()
          if (res.code == 200) {
            showDialog.value = false
            closeToast()
            commentContent.value = ""
            if (res.data == "201" || res.data == "202") {
              showNotify({ type: "warning", duration: 600, message: res.message })
              router.push({ path: "/projectDemand" })
            } else {
              inputDisabled.value = false
              showNotify({ type: "success", message: "回复成功" })
              // 刷新数据
              getDtail(route.query.id)
              // 刷新数据
              list.value = []
              listRef.value?.onRefresh()
            }
          } else {
            closeToast()
            showNotify({ type: "danger", message: res.message })
          }
        })
      } else {
        inputDisabled.value = false
      }
    } else {
      inputDisabled.value = false
    }
  }
}
// 点赞取消点赞
const dz = async () => {
  //   判断是否登录
  if (!getTokenIn()) {
    showNotify({ type: "warning", duration: 500, message: "请登录" })
  } else {
    var newDatas = {
      originalSfid: route.query.id
    }
    showLoadingToast({
      message: "加载中"
    })
    var newUrl: any = datas.value.isDZ == "1" ? removeUpvoteApi : upvoteApi
    newUrl(newDatas).then((res: any) => {
      closeToast()
      if (res.code == 200) {
        showDialog.value = false
        var text = datas.value.isDZ == "1" ? "取消点赞成功" : "点赞成功"
        closeToast()
        showNotify({ type: "success", message: text })
        // 刷新数据
        getDtail(route.query.id)
      } else {
        closeToast()
        showNotify({ type: "danger", message: res.message })
      }
    })
  }
}
// 收藏取消收藏
const sc = async () => {
  //   判断是否登录
  if (!getTokenIn()) {
    showNotify({ type: "warning", duration: 500, message: "请登录" })
  } else {
    var newDatasNo = route.query.id
    var newDatasHas = {
      originalSfid: route.query.id,
      type: "project"
    }
    showLoadingToast({
      message: "加载中"
    })
    var newUrl: any = datas.value.isSC == "1" ? removeCollectApi : collectApi
    var params = datas.value.isSC == "1" ? newDatasNo : newDatasHas
    newUrl(params).then((res: any) => {
      closeToast()
      if (res.code == 200) {
        showDialog.value = false
        var text = datas.value.isSC == "1" ? "取消收藏成功" : "收藏成功"
        closeToast()
        showNotify({ type: "success", message: text })
        // 刷新数据
        getDtail(route.query.id)
      } else {
        closeToast()
        showNotify({ type: "danger", message: res.message })
      }
    })
  }
}
// 现状照片点击预览
const openImagePreview = (images: any, index: number) => {
  console.log(images)
  var imgs: any = []
  images.map((element: any) => {
    imgs.push(DataList.UpdtImagePrefix() + element.sfid)
  })
  showImagePreview({
    images: imgs,
    showIndex: true,
    loop: false,
    closeable: true,
    startPosition: index
  })
}

return (_ctx: any,_cache: any) => {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_P = _resolveComponent("P")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_search = _resolveComponent("van-search")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (datas.value.headResourceDetail)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            fit: "cover",
            src: getImg(datas.value.headResourceDetail?.sfid),
            alt: ""
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("img", _hoisted_4)),
      _createElementVNode("p", null, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(datas.value.name), 1),
        _createElementVNode("span", _hoisted_6, "发布于：" + _toDisplayString(datas.value.shelfTime), 1)
      ])
    ]),
    (datas.value.pictureFilesDetail?.length > 0)
      ? (_openBlock(), _createBlock(_component_van_swipe, {
          key: 0,
          class: "swipe-ctn",
          autoplay: 3000,
          onChange: onChange
        }, {
          indicator: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, _toDisplayString(current.value + 1) + "/" + _toDisplayString(datas.value.pictureFilesDetail?.length), 1)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value.pictureFilesDetail, (item, i) => {
              return (_openBlock(), _createBlock(_component_van_swipe_item, {
                key: i,
                onClick: ($event: any) => (openImagePreview(datas.value.pictureFilesDetail, i))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "home_img",
                    fit: "cover",
                    src: getImg(item.sfid),
                    alt: ""
                  }, null, 8, _hoisted_7)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("p", _hoisted_11, [
          (datas.value.xqlx)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(datas.value.xqlx == '0' ? 'want' : 'has')
              }, _toDisplayString(datas.value.xqlx == "0" ? "要" : "有"), 3))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(datas.value.xqbt), 1)
        ]),
        _createElementVNode("p", _hoisted_12, _toDisplayString(datas.value.xqms), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("p", _hoisted_15, _toDisplayString(datas.value.lxfs || "暂无"), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("p", _hoisted_18, _toDisplayString(getAreaName(datas.value.szcsbm)), 1)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("p", _hoisted_21, _toDisplayString(datas.value.zylx), 1)
      ]),
      (datas.value.fjFilesDetail?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _hoisted_23,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.value.fjFilesDetail, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (_unref(commons).downloadAttachment(item.sfid, item.fileName)),
                class: "file_name",
                key: i + '01'
              }, _toDisplayString(item.fileName), 9, _hoisted_24))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("p", _hoisted_26, "评论（" + _toDisplayString(datas.value.pls > 99 ? "99+" : datas.value.pls) + "）", 1),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(ListWithRefreshAndLazyLoad, {
            ref_key: "listRef",
            ref: listRef,
            list: list.value,
            "onUpdate:list": _cache[2] || (_cache[2] = ($event: any) => ((list).value = $event)),
            params: params.value,
            getDataAPI: _unref(getDataAPI),
            onTotal: getData
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list-item comment_li",
                  id: i == list.value?.length - 1 ? 'list_last' : '',
                  key: i,
                  style: {"padding-bottom":"10px"}
                }, [
                  _createElementVNode("p", _hoisted_29, [
                    (item.commentHeadResourceDetail)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("img", {
                            fit: "cover",
                            src: getImg(item.commentHeadResourceDetail.sfid),
                            alt: ""
                          }, null, 8, _hoisted_30),
                          _createTextVNode(_toDisplayString(item.commentUserName), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_31,
                          _createTextVNode(_toDisplayString(item.commentUserName), 1)
                        ], 64))
                  ]),
                  _createVNode(_component_P, { class: "content" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.commentContent), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("p", _hoisted_32, [
                    _createElementVNode("span", null, _toDisplayString(item.commentTime), 1),
                    _createElementVNode("span", {
                      onClick: ($event: any) => (focusInput(item, item.commentUserName, list.value?.length - 1))
                    }, "回复", 8, _hoisted_33),
                    _createVNode(_component_van_popup, {
                      show: showDialog.value,
                      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event)),
                      overlay: true,
                      position: "bottom",
                      style: { width: '100%' }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_34, [
                          _createVNode(_component_van_field, {
                            modelValue: inputValue.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
                            name: "需求描述",
                            label: "",
                            ref_for: true,
                            ref_key: "inputRef",
                            ref: inputRef,
                            focus: true,
                            autofocus: "",
                            maxlength: "200",
                            placeholder: aa.value,
                            rules: [{ required: true, message: '请输入回复内容' }]
                          }, null, 8, ["modelValue", "placeholder"]),
                          _createElementVNode("div", _hoisted_35, [
                            _createVNode(_component_van_button, {
                              round: "",
                              color: "#ffcd01",
                              type: "primary",
                              size: "small",
                              onClick: ($event: any) => (onClickConfirm(item)),
                              disabled: inputDisabled2.value,
                              style: {"position":"absolute","right":"15px","width":"20%","top":"15px"}
                            }, {
                              default: _withCtx(() => [
                                _hoisted_36
                              ]),
                              _: 2
                            }, 1032, ["onClick", "disabled"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["show"]),
                    (item.self == '1')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          style: {"margin-left":"5px","color":"#ff4848"},
                          onClick: ($event: any) => (onClickDelete(item))
                        }, "删除", 8, _hoisted_37))
                      : _createCommentVNode("", true)
                  ]),
                  (item.childYcProjectRequireCommentRes?.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.childYcProjectRequireCommentRes, (iitem, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "list-item comment_li",
                            key: index
                          }, [
                            (item.ADDNUM ? index <= item.ADDNUM * 10 : index < 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _createElementVNode("div", null, [
                                    (iitem.commentHeadResourceDetail)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_40, [
                                          _createElementVNode("img", {
                                            fit: "cover",
                                            src: getImg(iitem.commentHeadResourceDetail.sfid)
                                          }, null, 8, _hoisted_41),
                                          _createTextVNode(_toDisplayString(iitem.commentUserName), 1)
                                        ]))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_42, [
                                          _hoisted_43,
                                          _createTextVNode(_toDisplayString(iitem.commentUserName), 1)
                                        ]))
                                  ]),
                                  _createVNode(_component_P, { class: "content" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("回复" + _toDisplayString(iitem.replyUserName || item.commentUserName) + ":" + _toDisplayString(iitem.commentContent), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("p", _hoisted_44, [
                                    _createElementVNode("span", null, _toDisplayString(iitem.commentTime), 1),
                                    _createElementVNode("span", {
                                      onClick: ($event: any) => (focusInput(iitem, iitem.commentUserName, list.value?.length - 1))
                                    }, "回复", 8, _hoisted_45),
                                    (iitem.self == '1')
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          style: {"margin-left":"5px","color":"#ff4848"},
                                          onClick: ($event: any) => (onClickDelete(iitem))
                                        }, "删除", 8, _hoisted_46))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (
                  item.childYcProjectRequireCommentRes?.length > 1 &&
                  item.childYcProjectRequireCommentRes?.length - (item.ADDNUM || 0) * 10 > 0
                )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "zk",
                        onClick: _withModifiers(($event: any) => (zk(item.commentHeadResourceDetail, i)), ["stop"])
                      }, _toDisplayString(showFlag.value ? "收起" : "展开") + " " + _toDisplayString(item.ADDNUM
                    ? item.childYcProjectRequireCommentRes?.length - 1 - item.ADDNUM * 10
                    : item.childYcProjectRequireCommentRes?.length - 1) + " 条回复 ", 9, _hoisted_47))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_28))
              }), 128))
            ]),
            _: 1
          }, 8, ["list", "params", "getDataAPI"])
        ])
      ])
    ]),
    (plShow.value || dzShow.value || scShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          (plShow.value)
            ? (_openBlock(), _createBlock(_component_van_search, {
                key: 0,
                modelValue: commentContent.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((commentContent).value = $event)),
                class: "system-search page",
                placeholder: "评论",
                shape: "round",
                clearable: "",
                ref_key: "bottomInputRef",
                ref: bottomInputRef,
                maxlength: "200",
                "left-icon": "",
                onFocus: onFocus,
                onBlur: onSearch,
                onSearch: onSearch
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (!isShowOperate.value)
            ? (_openBlock(), _createBlock(_component_van_button, {
                key: 1,
                round: "",
                color: "#ffcd01",
                type: "primary",
                size: "small",
                onClick: onSearch,
                disabled: inputDisabled.value,
                style: {"position":"absolute","right":"15px","width":"20%","top":"15px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_49
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (isShowOperate.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("p", _hoisted_51, [
                  _hoisted_52,
                  _createTextVNode(_toDisplayString(datas.value.pls > 99 ? "99+" : datas.value.pls), 1)
                ]),
                (dzShow.value)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "d_z",
                      onClick: dz
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(datas.value.isDZ == '1' ? 'zan' : 'noZan')
                      }, null, 2),
                      _createTextVNode(_toDisplayString(datas.value.dzs > 99 ? "99+" : datas.value.dzs), 1)
                    ]))
                  : _createCommentVNode("", true),
                (scShow.value)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      class: "s_c",
                      onClick: sc
                    }, [
                      _createElementVNode("span", {
                        class: _normalizeClass(datas.value.isSC == '1' ? 'sc' : 'noSc')
                      }, null, 2),
                      _createTextVNode(_toDisplayString(datas.value.scs > 99 ? "99+" : datas.value.scs), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})